var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-container"},[_c('e-title',{attrs:{"content":_vm.title.field1 || ''}}),_c('card',{attrs:{"to":"/product","special-link-key":"description","is-link":true,"items":_vm.items,"description":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }